import { render } from "./section-header.vue?vue&type=template&id=7c39ba6c"
import script from "./section-header.vue?vue&type=script&lang=js"
export * from "./section-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__